import i18n from 'i18next';

import { ButtonVariant } from '@/components/generic/Button/button-config';
import { LiveStreamModalType } from '@/enums';
import { ImageBlueBoldIcon as ImageIcon, PhotoFilmIcon, PlusIcons } from '@/resources';

export const getUploadOptions = (
  hasContentManagementAccess: boolean,
  hasCoverPhotoCreationAccess: boolean
) =>
  [
    hasContentManagementAccess && {
      value: LiveStreamModalType.UPLOADED_CONTENT,
      icon: <PhotoFilmIcon className='mr-1 w-6 text-primary-blue' />,
      label: i18n.t('uploadedContent', { ns: 'common' })
    },
    hasCoverPhotoCreationAccess && {
      value: LiveStreamModalType.COVER_PHOTO,
      icon: <ImageIcon fill='var(--color-primary-blue)' className='mr-1 w-6' />,
      label: i18n.t('coverPhotos', { ns: 'common' })
    },
    hasContentManagementAccess && {
      value: LiveStreamModalType.UPLOAD_NEW,
      icon: <PlusIcons fill='var(--color-primary-blue)' className='mr-1 w-6' />,
      label: i18n.t('uploadNew', { ns: 'common' })
    }
  ].filter(Boolean);

export const getLabelMapping = (t: (key: string) => string): Record<number, string> => ({
  [LiveStreamModalType.UPLOADED_CONTENT]: t('uploadedContent'),
  [LiveStreamModalType.COVER_PHOTO]: t('coverPhotos'),
  [LiveStreamModalType.WAITING_SCREEN]: t('waitingScreen')
});

export const getDescriptionMapping = (t: (key: string) => string): Record<number, string> => ({
  [LiveStreamModalType.UPLOADED_CONTENT]: t('pleaseChooseWaitingScreen'),
  [LiveStreamModalType.COVER_PHOTO]: t('pleaseChooseWaitingScreen'),
  [LiveStreamModalType.TURN_ON_LIVESTREAM]: t('turnOnTheLiveStream')
});

export const buttonTypeMapping: Record<number, ButtonVariant> = {
  [LiveStreamModalType.UPLOADED_CONTENT]: ButtonVariant.SECONDARY,
  [LiveStreamModalType.COVER_PHOTO]: ButtonVariant.SECONDARY
};
